"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var Box_1 = __importDefault(require("@mui/material/Box"));
var pick_1 = __importDefault(require("lodash/pick"));
var react_1 = __importDefault(require("react"));
var react_redux_1 = require("react-redux");
var IconButtons_1 = require("atomicComponents/molecules/IconButtons/IconButtons");
var backend_1 = require("utils/backend");
var hooks_1 = require("utils/hooks");
var single_1 = require("utils/selectors/single");
var constants_1 = require("../constants");
var context_1 = require("../context");
var ExcludeIncludeModal_1 = __importDefault(require("../Modals/ExcludeIncludeModal"));
var utils_1 = require("../utils");
var ExcludeOrg = function (_a) {
    var _b;
    var item = _a.item;
    var _c = __read(react_1.default.useState(null), 2), openModal = _c[0], setOpenModal = _c[1];
    var profile = (0, react_redux_1.useSelector)(single_1.selectProfileWithId);
    var _d = __read((0, hooks_1.useSubmitter)('users', profile.id), 1), userSubmitter = _d[0];
    var _e = __read((0, backend_1.useCall)('misc-excludeorganizationvendorscall', {
        isRevert: item.isExcluded,
        companyId: item.companyId,
        orgVendors: (0, utils_1.hasVendor)(item) ? [(0, pick_1.default)(item, 'rechargedOrganizationId', 'rechVendorId')] : [],
    }), 2), excludeOrg = _e[0], isExcludingOrg = _e[1];
    var selectedIds = (0, context_1.useSelectedRecharges)().selectedIds;
    if (constants_1.NON_ACTIONABLE_STATES.includes(item.rechargerStatus) || selectedIds.length || (item.isExcluded && !(0, utils_1.isExcludedOrg)(item))) {
        return (0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: "\u00A0" });
    }
    var targetStatus = item.isExcluded ? 'include' : 'exclude';
    var onConfirm = function () { return excludeOrg()().then(function () { return setOpenModal(null); }); };
    var handleClick = function () {
        var _a;
        if ((_a = profile.doNotShowAgain) === null || _a === void 0 ? void 0 : _a["".concat(targetStatus, "Org")]) {
            return excludeOrg()();
        }
        return setOpenModal(item.isExcluded ? 'include' : 'exclude');
    };
    var checkboxOnChange = function () {
        var _a;
        var _b;
        return openModal && userSubmitter({
            doNotShowAgain: (_a = {}, _a["".concat(openModal, "Org")] = !((_b = profile.doNotShowAgain) === null || _b === void 0 ? void 0 : _b["".concat(openModal, "Org")]), _a),
        });
    };
    return ((0, jsx_runtime_1.jsxs)(Box_1.default, __assign({ className: isExcludingOrg ? '' : 'showOnHover', display: "flex", height: "100%", flexWrap: "wrap", alignContent: "center", pl: 0.5 }, { children: [item.isExcluded
                ? ((0, jsx_runtime_1.jsx)(IconButtons_1.UndoButton, { outlined: true, iconSize: 16, tooltipTitle: "Revert exclusion", onClick: handleClick, isSending: isExcludingOrg, className: "highlightInput" }))
                : ((0, jsx_runtime_1.jsx)(IconButtons_1.RemoveButton, { outlined: true, iconSize: 16, tooltipTitle: "Exclude organization from vendor", onClick: handleClick, isSending: isExcludingOrg, className: "highlightInput", neutralByDefault: false })), openModal && ((0, jsx_runtime_1.jsx)(ExcludeIncludeModal_1.default, __assign({ open: true, actionType: openModal, onClose: function () { return setOpenModal(null); }, title: "Would you like to ".concat(openModal, " this organisation?"), buttonAction: onConfirm, isSending: isExcludingOrg, value: (_b = profile.doNotShowAgain) === null || _b === void 0 ? void 0 : _b["".concat(openModal, "Org")], checkboxOnChange: checkboxOnChange }, { children: openModal === 'exclude'
                    // eslint-disable-next-line max-len
                    ? 'Any existing or future charges imported for this organisation will be ignored and not invoiced. You can always revert this.'
                    // eslint-disable-next-line max-len
                    : 'All existing charges linked to this organisation will be included in the next invoice. If you wish to exclude older charges, do it manually.' })))] })));
};
exports.default = ExcludeOrg;
